var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMoveList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.25,
    height: 18,
    viewBox: "0 0 20.25 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,10.281H8.438v1.688H0Z",
    fill: "#3b3b3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,14.641H13.219v1.688H0Z",
    fill: "#3b3b3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13,2.25H17.3L15.6,0.6L16.75,0L20,3L16.75,6L15.6,5.4L17.3,3.75H13Z",
    fill: "#3b3b3b"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoveList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moveList.4ddbb328.svg";
export { ForwardRef as ReactComponent };